import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const dominios = {
	state: {
		dominios: '',
		interesesCV: [],
		programas: [],
		titulacionesEmpresa: '',
		motivosRechazo: '',
		aniosForo: [],
		provincias: '',
		localidades: '',
		provinciasComplet: {}
	},
	getters: {
		getDominio: state => {
			return (value) => {
				return state.dominios[value];
			}
		},
		getDominios: state => state.dominios,
		getInteresesCV: state => state.interesesCV,
		getProgramas: state => state.programas,
		getPaises: state => {
			if (!!state.dominios.paises) {
				let paises = Object.entries(state.dominios.paises);
				return paises.sort(function (p1, p2) {
					return (p1[1] < p2[1]) ? -1 : 1;
				});
			}
		},
		getDominiosOrder: state => {
			let dominios = new Object();

			if (!!state.dominios) {
				Object.entries(state.dominios).forEach(d => {
					if (!!d[1]) {
						dominios[d[0]] = Object.entries(d[1]).sort(function (p1, p2) {
							return (p1[1] < p2[1]) ? -1 : 1;
						});
					}
				});
			}

			return dominios;

		},
		getProvincias: state => {
			if (!!state.dominios.provincias) {
				let provincias = Object.entries(state.dominios.provincias);
				return provincias.sort(function (p1, p2) {
					return (p1[1] < p2[1]) ? -1 : 1;
				});
			}
		},
		getProvinciasComplet: state => {
			if (!!state.provinciasComplet) {
				return state.provinciasComplet;
			}
		},
		getLocalidadesbyIdProvincia: (state) => (idProvincia) => {
			let entry = null
			// console.log(idProvincia)
			if (Object.entries(state.provinciasComplet[idProvincia].localidades).length > 0) {
				//console.log(Object.entries(state.provinciasComplet[idProvincia].localidades).length)
				entry = state.provinciasComplet[idProvincia].localidades
			} else {
				if (JSON.parse(localStorage.getItem('provinciasLocalidades'))) {
					let localStoreProvinciasLocalidades = JSON.parse(localStorage.getItem('provinciasLocalidades'))
					entry = localStoreProvinciasLocalidades[idProvincia].localidades

				}
				else {
					return entry = 0
				}
			}
			return entry;
		},
		getAreasFuncionales: state => {
			if (!!state.dominios.areasFuncionales) {

				let areasFuncionales = Object.entries(state.dominios.areasFuncionales);

				let otrosString = ['otras', 'otros'];

				//COPIA DE OTROS
				let otros = areasFuncionales.filter(e => { return (otrosString.some(s => s.toLowerCase() == e[1].toLowerCase())) })[0];

				//SACO EL CAMPO "OTROS";
				areasFuncionales = areasFuncionales.filter(e => { return !(otrosString.some(s => s.toLowerCase() == e[1].toLowerCase())) });


				areasFuncionales = areasFuncionales.sort(function (p1, p2) {
					return (p1[1] < p2[1]) ? -1 : 1;
				});

				if (!!otros) {
					areasFuncionales.push(otros);
				}

				return areasFuncionales;

			}
		},
		getSectoresActividad: state => {
			if (!!state.dominios.sectoresActividad) {
				let sectoresActividad = Object.entries(state.dominios.sectoresActividad);
				return sectoresActividad.sort(function (p1, p2) {
					return (p1[1] < p2[1]) ? -1 : 1;
				});
			}
		},
		getTiposContrato: state => {
			if (!!state.dominios.tiposContrato) {
				let tiposContrato = Object.entries(state.dominios.tiposContrato);
				return tiposContrato.sort(function (p1, p2) {
					return (p1[1] < p2[1]) ? -1 : 1;
				});
			}
		},
		getTiposDocumentoAlumnoPracticas: state => {
			if (!!state.dominios.tiposDocumentoAlumnoPracticas) {
				let tiposDocumentoAlumnoPracticas = Object.entries(state.dominios.tiposDocumentoAlumnoPracticas);
				return tiposDocumentoAlumnoPracticas.sort(function (p1, p2) {
					return (p1[1] < p2[1]) ? -1 : 1;
				});
			}
		},
		getEstadosCandidaturaAlumno: state => {
			if (!!state.dominios.estadosCandidaturasAlumno) {
				let tiposestadosCandidaturasAlumno = Object.entries(state.dominios.estadosCandidaturasAlumno);
				return tiposestadosCandidaturasAlumno.sort(function (p1, p2) {
					return (p1[1] < p2[1]) ? -1 : 1;
				});
			}
		},
		getTitulacionesEmpresa: state => {
			if (!!state.titulacionesEmpresa) {
				return state.titulacionesEmpresa;
			}
		},
		getmotivosRechazo: state => {
			if (!!state.motivosRechazo) {
				return state.motivosRechazo;
			}
		},
		Complet: state => {

			return (idProvincia) => {

				let localidades;

				if (!!state.dominios.localidades) {
					localidades = state.dominios.localidades.filter(l => l.idProvincia == idProvincia);
					localidades = localidades.sort(function (p1, p2) {
						return (p1.descripcion < p2.descripcion) ? -1 : 1;
					});
				}



				return localidades

			}
		},
		getAmbitos: state => {

			let ambitos;

			if (!!state.dominios.ambitos) {
				ambitos = Object.values(state.dominios.ambitos).sort(function (p1, p2) {
					return (p1.ambitoEstudo < p2.ambitoEstudo) ? -1 : 1;
				});
			}
			return ambitos

		},
		getEspecialidades: state => {

			let especialidades = new Array();

			if (!!state.dominios && !!state.dominios.ambitos) {
				Object.values(state.dominios.ambitos).forEach(e => {
					Object.entries(e.especialidadesAmbitoEstudio).forEach(especialidad => {
						especialidades.push(especialidad);
					});
				})
			}

			especialidades.sort(function (p1, p2) {
				return (p1[1].normalize("NFD").replace(/[\u0300-\u036f]/g, "") < p2[1].normalize("NFD").replace(/[\u0300-\u036f]/g, "")) ? -1 : 1;
			});

			return especialidades;
		},
		getAniosForo: state => state.aniosForo,
		getTipoContactoEmpresa: state => {

			let tipos;


			if (!!state.dominios.tiposContacoEmpresa) {
				tipos = Object.entries(state.dominios.tiposContacoEmpresa).sort(function (p1, p2) {
					return (p1[1] < p2[1]) ? -1 : 1;
				});
			}

			return tipos;

		},

	},
	actions: {
		requestDominios: ({ commit, getters, dispatch }) => {
			axios.get(`/api/Dominios/dominios`).then(response => {
				(response.data.status == 0) ? commit('setDominios', response.data.datos) : '';
				dispatch('requestDominiosList');
			})
				.catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
		},
		requestDominiosList: ({ commit, getters, dispatch }) => {
			let list = [
				'localidades',
				'tiposVia',
				'titulaciones',
				'ProgramasInformaticos',
				'competenciasfesionales',
				'tipoEstanciasExtranjero',
				'nivelesProgramasInformaticos',
				'tiposContacoEmpresa',
				'tipoMotivoCambioEstadoCandidatura',
				'tiposFormacionAcademica',
				'tiposDocumentoIdentidad',
				'tiposContratoExperiencias',
				'tiposNivelesTitulacion',
				'subtiposContratoExperiencias',
				'actividadesrofesionales',
				'ambitosEstudio',
				'ragosFacturacion',
				'numeroDeEmpleados',
				'tipoOpcionPublicacionOferta',
				'TagsInteresAlumno',
				'rangosDeCreditos',

			];

			list.forEach(el => {
				axios.get(`/api/Dominios/${el}/${getters.getLanguage}`).then(response => {
					if (response.data.datos.length != 0) {
						let data = [el, response.data.datos];
						(response.data.status == 0) ? commit('setDominiosList', data) : '';
					}
				}).catch(function (error) { });

			});

		},
		requestDominiosLocalidades: ({ commit, getters, dispatch }) => {
			axios.get(`/api/Dominios/localidades/${getters.getLanguage}`).then(response => {
				(response.data.status == 0) ? commit('setDominiosLocalidades', response.data.datos) : '';
			}).catch(function (error) { });
			axios.get(`/api/Dominios/provincias/${getters.getLanguage}`).then(response => {
				(response.data.status == 0) ? commit('setDominiosProvincias', response.data.datos) : '';
			}).catch(function (error) { });
		},


		requestIntereses: function ({ commit, dispatch }) {
			return new Promise((resolve, reject) => {
				axios.get(`api/Dominios/TagsInteresAlumno`).then(response => {
					(response.data.status == 0) ? commit('setInteresesCV', response.data.datos) : '';
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});

		},
		requestProgramas: function ({ commit, dispatch }) {
			return new Promise((resolve, reject) => {
				axios.get(`api/Dominios/ProgramasInformaticos`).then(response => {
					(response.data.status == 0) ? commit('setProgramas', response.data.datos) : '';
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		requestTitulacionesEmpresa: function ({ commit, dispatch }) {
			return new Promise((resolve, reject) => {
				axios.get(`api/Dominios/titulaciones`).then(response => {
					if (response.data.status == 0) {
						commit('setTitulaciones', response.data.datos);
						resolve(true);
					}
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		requestMotivosRechazo: function ({ commit, dispatch }) {
			return new Promise((resolve, reject) => {
				axios.get(`api/Dominios/tipoMotivoCambioEstadoCandidatura`).then(response => {
					if (response.data.status == 0) {
						commit('setMotivoRechazoPracticas', response.data.datos);
						resolve(true);
					}
				})
					.catch(function (error) { });
			});
		},
		createAniosForo({ commit }) {
			let init = 2010;
			let years = [];
			let finish = new Date().getFullYear();

			while (init <= finish) {
				years.push(init);
				init++;
			}

			commit('setAniosForo', years);

		},
		requestEmpresasPorProvincia: ({ commit, getters, dispatch }, idProvincia) => {
			return new Promise((resolve, reject) => {
				axios.get(`/api/Dominios/centrosEducativosDeProvincia/${idProvincia}`).then(response => {
					if (response.data.status == 0) {
						resolve(response.data.datos)
					}
				}).catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
			});
		},
	},
	mutations: {
		setDominio: function (state, data) {
			state.dominios[data[0]] = data[1];
		},
		setDominiosList: function (state, data) {
			if (Object.values(data[1]).length != 0) {
				state.dominios[data[0]] = data[1];
			}

		},
		setDominios: function (state, data) {
			state.dominios = data;
			state.provinciasComplet = data.provincias
			Object.entries(state.provinciasComplet).forEach(element => {
				if (state.provinciasComplet[element[0]] == null) {
					state.provinciasComplet[element[0]] = {}
				}
				state.provinciasComplet[element[0]] = {
					"nameProvincia": element[1],
					"idProvincia": element[0],
					"localidades": {}
				}
			});
		},
		setDominiosLocalidades: function (state, data) {
			state.localidades = data
			state.provinciasComplet = state.provincias
			Object.entries(state.provinciasComplet).forEach(element => {
				if (state.provinciasComplet[element[0]] == null) {
					state.provinciasComplet[element[0]] = {}
				}
				state.provinciasComplet[element[0]] = {
					"nameProvincia": element[1],
					"idProvincia": element[0],
					"localidades": {}
				}
			});
			if (state.localidades) {
				//console.log('carga localidades')
				Object.values(state.localidades).forEach(element => {
					state.provinciasComplet[element.idProvincia].localidades[element.idLocalidad] = element.descripcion
				})
				localStorage.setItem('provinciasLocalidades', JSON.stringify(state.provinciasComplet));
			}
		},
		setDominiosProvincias: function (state, data) {
			state.provincias = data
		},

		setInteresesCV: function (state, data) {
			state.interesesCV = data;
		},
		setProgramas: function (state, data) {
			state.programas = Object.values(data);
		},
		setTitulaciones: function (state, data) {
			state.titulacionesEmpresa = Object.values(data);
		},
		setMotivoRechazoPracticas: function (state, data) {
			state.motivosRechazo = data.sort((a, b) => a.descripcion > b.descripcion ? 1 : -1);
		},
		setAmbitosEstudio: function (state, data) {
			state.ambitos.ambitosEstudio = data;
		},
		setEspecialidadesAmbitoEstudio: function (state, data) {
			state.ambitos.especialidadesAmbitoEstudio[data[0]] = data[1];
		},
		setAniosForo(state, years) {
			state.aniosForo = years;
		}
	}
}

export default dominios;



// WEBPACK FOOTER //
// ./src/store/dominios.js